import { useEffect, useState } from "react";
import { Scissors, Clock, ImageIcon, HandCoins } from "lucide-react";

/** Servicios del negocio: cada uno con sus fotos, descripción y su botón de reservar. */
function ServicesView({ setCurrentView, clientData, preloadedImages, setSelectedService }) {
  const [services, setServices] = useState(clientData?.business?.services || []);
  useEffect(() => { setServices(clientData?.business?.services || []); }, [clientData]);

  const select = (service) => { setSelectedService(service); setCurrentView("calendar"); };

  // Con un solo servicio no hay nada que elegir: se pasa directo a día y hora (el resumen
  // del calendario ya muestra nombre, duración y precio). La pantalla con una sola
  // tarjeta y el resto vacío se veía rota.
  const single = services.length === 1;
  useEffect(() => { if (single) select(services[0]); }, [single]); // eslint-disable-line react-hooks/exhaustive-deps
  if (single) return null;

  return (
    <section className="cp-pub-services">
      <header className="cp-page-head">
        <div>
          <h2 className="cp-page-title">Elige un servicio</h2>
          <p className="cp-page-sub">Después eliges el día y la hora.</p>
        </div>
      </header>
      {services.length === 0 ? (
        <div className="cp-card"><div className="cp-empty"><ImageIcon size={36} /><h3>Aún no hay servicios</h3><p>Vuelve más tarde o escríbele al negocio.</p></div></div>
      ) : (
        <ul className="cp-list cp-pub-svclist">
          {services.map((service, index) => {
            const photos = preloadedImages?.[index] || [];
            const advance = service.requiresAdvance && service.advanceAmount;
            return (
              <li key={index} className="cp-card cp-pub-svc">
                {photos.length > 0 && (
                  <div className={`cp-pub-photos ${photos.length > 1 ? "cp-choice-strip" : "is-single"}`}>
                    {photos.map((src, k) => <img key={k} src={src} alt={`${service.name} ${k + 1}`} loading="lazy" draggable={false} />)}
                  </div>
                )}
                <div className="cp-pub-svc-body">
                  <div className="cp-pub-svc-row">
                    {photos.length === 0 && <span className="cp-pub-thumb"><Scissors size={20} /></span>}
                    <span className="cp-row-main">
                      <span className="cp-row-title">{service.name}</span>
                      <span className="cp-row-sub"><Clock size={13} /> {service.durationMinutes} min{advance ? <span className="cp-pill cp-pill-warn"><HandCoins size={11} /> Anticipo ${service.advanceAmount}</span> : null}</span>
                    </span>
                    <span className="cp-pub-svc-price">${service.price}</span>
                  </div>
                  {service.description && <p className="cp-muted">{service.description}</p>}
                  <button type="button" className="cp-btn cp-btn-primary cp-btn-block" onClick={() => select(service)}>Reservar este servicio</button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
export default ServicesView;
